export const typeBusBarMaterial = [

    {
        title: "Copper", "value": "Copper"
    },
    {
        title: "Aluminum", "value": "Aluminum"
    },
    {
        title: "Other", "value": "Other"
    },
]

export const copperMaterial = [
    { title: '0.188" | 4.78mm', "value": '0.188" | 4.78mm' },
    { title: '0.250" | 6.35mm', "value": '0.250" | 6.35mm' },
    { title: '0.125" | 3.18mm', "value": '0.125" | 3.18mm' },
    { title: '0.093" | 2.36mm', "value": '0.093" | 2.36mm' },
    { title: '0.064" | 1.63mm', "value": '0.064" | 1.63mm' },
]

export const AluminumMaterial = [
    { title: '11 gauge 0.120" | 3.05 mm', "value": '11 gauge 0.120" | 3.05 mm' },
    { title: '12 gauge 0.105" | 2.67 mm ', "value": '12 gauge 0.105" | 2.67 mm ' },
    { title: '13 gauge 0.090" | 2.29 mm', "value": '13 gauge 0.090" | 2.29 mm' },
    { title: '14 gauge 0.075" | 1.91 mm', "value": '14 gauge 0.075" | 1.91 mm' },
    { title: '16 gauge 0.060" | 1.52 mm', "value": '16 gauge 0.060" | 1.52 mm' },
    { title: '18 gauge 0.048" | 1.22 mm', "value": '18 gauge 0.048" | 1.22 mm' },
    { title: '20 gauge 0.036" | 0.91 mm', "value": '20 gauge 0.036" | 0.91 mm' },
    { title: '22 gauge 0.030" | 0.76 mm', "value": '22 gauge 0.030" | 0.76 mm' },

]

export const tinPlating = [
    { title: 'Yes', "value": 'Yes' },
    { title: 'No', "value": 'No' },
    { title: 'Not Sure', "value": 'Not Sure' },

]

export const bareMetal = [
    { title: 'No Finish', "value": 'No Finish' },
    { title: 'Vibratory Finish', "value": 'Vibratory Finish' },
    { title: 'Media Blasting', "value": 'Media Blasting' },
    { title: 'Grained Finish', "value": 'Grained Finish' },

]